function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.25 2.75a.75.75 0 011.5 0v6.5a.75.75 0 01-1.5 0v-6.5zM3.25 2.75a.75.75 0 011.5 0v6.5a.75.75 0 01-1.5 0v-6.5z",
  fill: "currentColor"
})));